/**
 * Formats phone numbers to the consistent format: (987)-654 3215
 * @param phoneNumber - The phone number to format (string or number)
 * @returns Formatted phone number string or fallback value
 */
export const formatPhoneNumber = (phoneNumber: string | number | null | undefined): string => {
  if (!phoneNumber) return 'N/A';
  
  // Remove all non-digit characters
  const cleaned = phoneNumber.toString().replace(/\D/g, '');
  
  // Check if we have exactly 10 digits
  if (cleaned.length !== 10) {
    return phoneNumber.toString(); // Return original if not 10 digits
  }
  
  // Format as (XXX)-XXX XXXX
  const areaCode = cleaned.slice(0, 3);
  const firstPart = cleaned.slice(3, 6);
  const secondPart = cleaned.slice(6, 10);
  
  return `(${areaCode})-${firstPart} ${secondPart}`;
};

/**
 * Validates if a phone number has the correct format and length
 * @param phoneNumber - The phone number to validate
 * @returns True if valid, false otherwise
 */
export const isValidPhoneNumber = (phoneNumber: string | number): boolean => {
  if (!phoneNumber) return false;
  
  const cleaned = phoneNumber.toString().replace(/\D/g, '');
  return cleaned.length === 10;
};

/**
 * Strips formatting from a phone number to get just the digits
 * @param phoneNumber - The formatted phone number
 * @returns Clean 10-digit string or empty string if invalid
 */
export const cleanPhoneNumber = (phoneNumber: string | number): string => {
  if (!phoneNumber) return '';
  
  const cleaned = phoneNumber.toString().replace(/\D/g, '');
  return cleaned.length === 10 ? cleaned : '';
};